import { LINE_COLORS } from '../LineChart/constants';

export const getOptionColors = (
  options: string[],
  palette: readonly string[] = LINE_COLORS,
): Map<string, string> => {
  return new Map(
    options.map((option, index) => {
      return [option, palette[index % palette.length]];
    }),
  );
};

export const resolveOptionColors = (
  previous: ReadonlyMap<string, string> | undefined,
  orderedOptions: string[],
  palette: readonly string[] = LINE_COLORS,
): ReadonlyMap<string, string> => {
  if (
    previous &&
    previous.size === orderedOptions.length &&
    orderedOptions.every((option) => previous.has(option))
  ) {
    return previous;
  }

  const colors = new Map<string, string>();
  const used = new Set<string>();

  orderedOptions.forEach((option) => {
    const kept = previous?.get(option);

    if (kept !== undefined) {
      colors.set(option, kept);
      used.add(kept);
    }
  });

  let cursor = 0;

  orderedOptions.forEach((option) => {
    if (colors.has(option)) {
      return;
    }

    while (cursor < palette.length && used.has(palette[cursor])) {
      cursor += 1;
    }

    const color =
      cursor < palette.length
        ? palette[cursor]
        : palette[colors.size % palette.length];

    colors.set(option, color);
    used.add(color);
  });

  return colors;
};
